import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import classNames from 'classnames';

import css from './Card.module.scss';

const Card = ({ id, src, alt, description, link, customClass }) => {
	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<div className={classNames(css.card, css[customClass])} data-aos="fade-up">
			<Img fixed={images[src].childImageSharp.fixed} alt={alt} />
			<p>{description}</p>
			<a
				href={link}
				className="linkArrow"
				target="_blank"
				rel="noopener noreferrer"
			>
				Read more
			</a>
		</div>
	);
};

const IMAGES_QUERY = graphql`
	{
		businessStandard: file(
			relativePath: { eq: "home/news/business-standard.png" }
		) {
			childImageSharp {
				fixed(width: 170) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		theET: file(relativePath: { eq: "home/news/the-et.png" }) {
			childImageSharp {
				fixed(width: 170) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		moneycontrol: file(relativePath: { eq: "home/news/moneycontrol.png" }) {
			childImageSharp {
				fixed(width: 170) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;

export default Card;
